import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { logDev } from "@/lib/logger";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loginPromptOpen, setLoginPromptOpen] = useState(false);
  const [requirementOpen, setRequirementOpen] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If OAuth callback in URL, skip /me - AuthCallback handles it
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (err) { logDev.warn("logout request failed:", err); }
    setUser(null);
    window.location.href = "/";
  }, []);

  const promptLogin = useCallback(() => setLoginPromptOpen(true), []);
  const closeLoginPrompt = useCallback(() => setLoginPromptOpen(false), []);
  const openRequirement = useCallback(() => setRequirementOpen(true), []);
  const closeRequirement = useCallback(() => setRequirementOpen(false), []);

  const value = useMemo(() => ({
    user, loading, setUser, refresh: checkAuth, logout,
    loginPromptOpen, promptLogin, closeLoginPrompt,
    requirementOpen, openRequirement, closeRequirement,
  }), [user, loading, checkAuth, logout, loginPromptOpen, promptLogin, closeLoginPrompt, requirementOpen, openRequirement, closeRequirement]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function login() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
